import api from './api';

export const addressesService = {
  getSuggestions: (query) => api.get('/addresses/suggestions', { params: { q: query } }),
};
